export default {
	// Price must be in €, not in cents. Spec to be number or string not formatted
	format(price, locale) {
		if (typeof price === 'undefined' || typeof locale === 'undefined') {
			throw new Error('params are missing');
		}

		price = price.toString();

		const integer = price.split('.')[0];
		const fraction = price.split('.')[1] || '00';
		const pattern = this.getPattern(locale);

		return this.applyPattern(integer, fraction, pattern);
	},

	getPattern(locale) {
		switch (locale) {
			case 'de_AT':
				return {
					separator: '.', // integer degree separator
					scheme: '€ XX,xx',
				};

			case 'de_CH':
				return {
					separator: '.',
					scheme: 'CHF XX.xx',
				};

			case 'en_GB':
				return {
					separator: '.',
					scheme: '£XX.xx',
				};

			default:
				return {
					separator: '.',
					scheme: 'XX,xx €',
				};
		}
	},

	applyPattern(integer, fraction, pattern) {
		if (!!pattern.separator && integer.length > 3) {
			integer = integer.split(/(?=(?:...)*$)/).join(pattern.separator);
		}

		return pattern.scheme.replace(/XX/, integer).replace(/xx/, fraction);
	},
};
